/* eslint-disable max-len */
export default function ControlController(
  $q,
  $rootScope,

  userService,
  alerts,
  authorizationService,
  confirmDialog,
  editControlDialog,
  loaderService,
  controlDataService,
  controlSharedModelService,
  ssDialogService,
  riskDataService,
  deleteControlConfirmDialog,
  syncControlConfirmDialog
) {
  const vm = this;

  vm.canExpand = true;
  vm.isExpanded = false;
  vm.handleEditClick = _handleEditClick;
  vm.handleDeleteClick = _handleDeleteClick;
  vm.handleExpandControlClick = _handleExpandControlClick;
  vm.handleUnassignClick = _handleUnassignClick;
  vm.handleBulkDeleteChange = _handleBulkDeleteChange;
  vm.handleSyncClick = _handleSyncClick;
  vm.handleSyncControlChange = _handleSyncControlChange;
  vm.controlLoaded = false;

  _activate();


  function _activate() {
    if (vm.assignAsset === true) {
      vm.tooltipAppendToSelector = '#assignAssetDialog';
    } else if (vm.isEditProcessDialog === true) {
      vm.tooltipAppendToSelector = '#editProcessDialog';
    } else if (vm.isApproveProcessDialog === true) {
      vm.tooltipAppendToSelector = '#approvePRAProcessDialog';
    } else if (vm.isEditAssetDialog === true) {
      vm.tooltipAppendToSelector = '#editAssetDialog';
    }
    _initPermissions();
    _initControlData();

    $rootScope.$on('refreshCustomerControl', (event, opt) => {
      if (opt.customerControlId === vm.controlDetail.customerControlId) {
        _refreshControl();
      }
    });
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initControlData() {
    if (vm.controlDetail) {
      vm.controlDetail = controlSharedModelService.transformToEffectivenessCssClass(vm.controlDetail);
    }
  }

  function _handleEditClick($event) {
    loaderService.showViewLoader = true;
    $q.all([
      getInitControlAdmin(),
      // controlDataService.getControlTypes(),
      // riskDataService.getRisks(),
      controlDataService.getControlById(vm.controlDetail.customerControlId)
    ]).then((response) => {
      loaderService.showViewLoader = false;
      ssDialogService.dialogs.controlAdmin.editControlDialog = ssDialogService.alert(
        editControlDialog.getOptions($event, {
          control: response[1].data.CustomerControl,
          controlTypes: response[1].data.CustomerControlTypes,
          risks: response[1].data.CustomerRiskData,
          risk: vm.risk,
          controlResults: controlSharedModelService.ControlResults,
          controlPreventiveEffectivenesses: controlSharedModelService.ControlPreventiveEffectivenesses,
          controlDetectiveEffectivenesses: controlSharedModelService.ControlDetectiveEffectivenesses,
          controlCorrectiveEffectivenesses: controlSharedModelService.ControlCorrectiveEffectivenesses,
          controlAdministrativeNatures: controlSharedModelService.ControlAdministrativeNatures,
          controlPhysicalNatures: controlSharedModelService.ControlPhysicalNatures,
          controlTechnicalNatures: controlSharedModelService.ControlTechnicalNatures,
          controlPrimaryControlTypes: controlSharedModelService.ControlPrimaryControlTypes,
          controlCompensatingControlTypes: controlSharedModelService.ControlCompensatingControlTypes,
          controlReviewSchedules: controlSharedModelService.ControlReviewSchedules,
          controlReviewTypes: controlSharedModelService.ControlReviewTypes,
        })
      );
      ssDialogService.show(ssDialogService.dialogs.controlAdmin.editControlDialog);
    });
  }

  function _handleDeleteClick($event) {
    ssDialogService.dialogs.controlAdmin.deleteControlConfirmDialog = ssDialogService.alert(
      deleteControlConfirmDialog.getOptions($event, {
        control: vm.controlDetail,
        process: vm.process,
        isEditProcessDialog: vm.isEditProcessDialog,
        isApproveProcessDialog: vm.isApproveProcessDialog,
        isPraProcessMain: vm.isPraProcessMain,
        risk: vm.risk,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.controlAdmin.deleteControlConfirmDialog);
  }

  function _handleExpandControlClick() {
    vm.isExpanded = !vm.isExpanded;
    if (!vm.controlLoaded) {
      _refreshControl();
    }
  }

  function _refreshControl() {
    loaderService.showViewLoader = true;
    controlDataService.getControl(vm.controlDetail.customerControlId).then((response) => {
      vm.controlDetail = angular.copy(response.data);
      vm.controlDetail = controlSharedModelService.transformToEffectivenessCssClass(vm.controlDetail);
      vm.controlLoaded = true;
      loaderService.showViewLoader = false;
    });
  }

  function _handleUnassignClick($event) {
    ssDialogService.dialogs.controlAdmin.unAssignControlDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unassign Control?',
        message: `Are you sure you want to unassign the Control, "${vm.controlDetail.name}" from the risk "${vm.risk.name}"?`,
        handleYesClick: () => {
          _handleConfirmUnassignClick();
        },
        handleNoClick: () => {
          _handleCancelUnassignClick();
        },
      })
    );

    ssDialogService.show(ssDialogService.dialogs.controlAdmin.unAssignControlDialog);
  }

  function _handleConfirmUnassignClick() {
    if (vm.controlDetail.customerRiskControl) {
      const _customerRiskControlId = vm.controlDetail.customerRiskControl.customerRiskControlId;
      const _risk = { customerRiskId: vm.risk.customerRiskId };
      controlDataService.unAssignControlsFromRisk(
        _customerRiskControlId
      )
        .then((response) => {
          if (response.status === 200) {
            alerts.success(`The control "${vm.controlDetail.name}" was successfully unassigned.`);
            $rootScope.$broadcast('refreshControls');
            $rootScope.$broadcast('refreshRiskControls', { risk: _risk });
            _closeUnassignDialog();
          } else {
            alerts.error('An error occurred while unassigning the control.');
          }
        });
    }
  }

  function _handleCancelUnassignClick() {
    _closeUnassignDialog();
  }

  function _closeUnassignDialog() {
    ssDialogService.hide(ssDialogService.dialogs.controlAdmin.unAssignControlDialog);
  }

  function getInitControlAdmin() {
    if (controlSharedModelService.ControlResults && controlSharedModelService.ControlResults.length > 0) {
      return Promise.resolve();
    }
    return controlDataService.initControlAdmin().then((getControlInitResponse) => {
      if (!getControlInitResponse.data) {
        alerts.error('Error occurred get control init data.');
      } else {
        if (getControlInitResponse.data.ControlResults) {
          controlSharedModelService.ControlResults = getControlInitResponse.data.ControlResults.result;
        }

        if (getControlInitResponse.data.ControlPreventiveEffectivenesses) {
          controlSharedModelService.ControlPreventiveEffectivenesses = getControlInitResponse.data.ControlPreventiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlDetectiveEffectivenesses) {
          controlSharedModelService.ControlDetectiveEffectivenesses = getControlInitResponse.data.ControlDetectiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlCorrectiveEffectivenesses) {
          controlSharedModelService.ControlCorrectiveEffectivenesses = getControlInitResponse.data.ControlCorrectiveEffectivenesses.result;
        }

        if (getControlInitResponse.data.ControlAdministrativeNatures) {
          controlSharedModelService.ControlAdministrativeNatures = getControlInitResponse.data.ControlAdministrativeNatures.result;
        }

        if (getControlInitResponse.data.ControlPhysicalNatures) {
          controlSharedModelService.ControlPhysicalNatures = getControlInitResponse.data.ControlPhysicalNatures.result;
        }

        if (getControlInitResponse.data.ControlTechnicalNatures) {
          controlSharedModelService.ControlTechnicalNatures = getControlInitResponse.data.ControlTechnicalNatures.result;
        }

        if (getControlInitResponse.data.ControlPrimaryControlTypes) {
          controlSharedModelService.ControlPrimaryControlTypes = getControlInitResponse.data.ControlPrimaryControlTypes.result;
        }

        if (getControlInitResponse.data.ControlCompensatingControlTypes) {
          controlSharedModelService.ControlCompensatingControlTypes = getControlInitResponse.data.ControlCompensatingControlTypes.result;
        }

        if (getControlInitResponse.data.ControlReviewSchedules) {
          controlSharedModelService.ControlReviewSchedules = getControlInitResponse.data.ControlReviewSchedules.result;
        }

        if (getControlInitResponse.data.ControlReviewTypes) {
          controlSharedModelService.ControlReviewTypes = getControlInitResponse.data.ControlReviewTypes.result;
        }

        if (getControlInitResponse.data.ControlTypes) {
          controlSharedModelService.ControlTypes = getControlInitResponse.data.ControlTypes.result;
        }
      }
    });
  }

  function _handleBulkDeleteChange() {
    $rootScope.$broadcast('selectBulkControlChange');
  }

  function _handleSyncControlChange() {
    $rootScope.$broadcast('selectSyncControlChange');
  }

  function _handleSyncClick($event) {
    ssDialogService.dialogs.controlAdmin.syncControlDialog = ssDialogService.alert(
      syncControlConfirmDialog.getOptions($event, {
        control: vm.controlDetail,
        controlType: vm.controlDetail.customerControlType,
        isMultipleControls: false,
        updateCallBack: _broadcastEvents,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.controlAdmin.syncControlDialog);
  }

  function _broadcastEvents() {
    if (vm.showSyncControl === true) {
      $rootScope.$broadcast('refreshSyncControls', { customerControlId: vm.controlDetail.customerControlId });
      $rootScope.$broadcast('refreshControlType', { customerControlTypeId: vm.controlDetail.customerControlType.customerControlTypeId });
    } else if (vm.risk) {
      $rootScope.$broadcast('refreshRiskControls', { risk: vm.risk });
    } else {
      $rootScope.$broadcast('refreshControlType', { customerControlTypeId: vm.controlDetail.customerControlType.customerControlTypeId });
    }
  }
}

ControlController.$inject = [
  '$q',
  '$rootScope',

  'userService',
  'alerts',
  'authorizationService',
  'confirmDialog',
  'editControlDialog',
  'loaderService',
  'controlDataService',
  'controlSharedModelService',
  'ssDialogService',
  'riskDataService',
  'deleteControlConfirmDialog',
  'syncControlConfirmDialog'
];
